export * from './dataSettings';
export * from './getData';
export * from './interceptor';
export * from './ngTableDefaultGetData';
export * from './results';


// WEBPACK FOOTER //
// ./~/angular1-template-loader!./src/core/data/index.ts